import { httpTools } from "@lib/redux/http-utils";
import { apiSlice } from "@features/application/api-slice";
import { EventVenuesCapacityOutputView } from "@features/reports/lib/venues-capacity";
import {
  ActivityAnalyticsOutputView,
  EventAnalyticsOutputView,
} from "@features/reports/types/analytics";
import routes from "@features/routes";
import {
  ReportServerMetadataOutputView,
  ReportServerTaskDownloadOutputView,
  ReportServerTaskInputView,
  ReportServerTaskOutputView,
} from "@features/reports/types/report-server";

export const reportsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEventReport: httpTools.getOnceResponse<EventAnalyticsOutputView, EventAnalyticsOutputView>(
      builder,
      routes.reports.api.event_report,
      null,
      null,
      null,
      "/api/v1",
    ),
    getEventVenuesCapacity: httpTools.getOnceResponse<
      EventVenuesCapacityOutputView,
      EventVenuesCapacityOutputView
    >(builder, routes.reports.api.event_venues_capacity, null, null, null, "/api/v1"),
    getActivityReport: httpTools.getOnceResponse<
      ActivityAnalyticsOutputView,
      ActivityAnalyticsOutputView
    >(builder, routes.reports.api.activity_report, null, null, null, "/api/v1"),
    getReportServerMetadata: httpTools.getMultipleResponse<
      ReportServerMetadataOutputView,
      ReportServerMetadataOutputView
    >(builder, routes.reports.api.report_server_metadata, null, null, null, "/api/v1"),
    getReportServerTasks: httpTools.getMultipleResponse<
      ReportServerTaskOutputView,
      ReportServerTaskOutputView
    >(builder, routes.reports.api.report_server_tasks, "ReportServerTask", null, null, "/api/v1"),
    getReportServerTask: httpTools.getOnceResponse<
      ReportServerTaskOutputView,
      ReportServerTaskOutputView
    >(builder, routes.reports.api.report_server_task, "ReportServerTask", null, null, "/api/v1"),
    postReportServerTask: httpTools.postOnceResponse<
      ReportServerTaskOutputView,
      ReportServerTaskOutputView,
      ReportServerTaskInputView
    >(
      builder,
      routes.reports.api.report_server_tasks,
      "ReportServerTask",
      null,
      "list",
      null,
      "/api/v1",
    ),
    postReportServerTaskDownloadGrant: httpTools.postOnceResponse<
      ReportServerTaskDownloadOutputView,
      ReportServerTaskDownloadOutputView,
      never
    >(
      builder,
      routes.reports.api.report_server_task_download_grant,
      null,
      null,
      null,
      null,
      "/api/v1",
    ),
    postReportServerTaskRestart: httpTools.postOnceResponse<never, never, never>(
      builder,
      routes.reports.api.report_server_task_restart,
      "ReportServerTask",
      null,
      "once",
      null,
      "/api/v1",
    ),
  }),
  overrideExisting: false,
});

export const {
  useGetEventReportQuery,
  useGetEventVenuesCapacityQuery,
  useGetActivityReportQuery,
  useGetReportServerMetadataQuery,
  useGetReportServerTaskQuery,
  useGetReportServerTasksQuery,
  usePostReportServerTaskMutation,
  usePostReportServerTaskDownloadGrantMutation,
  usePostReportServerTaskRestartMutation,
} = reportsApi;
